/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useMemo } from 'react';
import { Fab, Snackbar, Alert } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { useDispatch, useSelector } from 'dva';
import { useLocation, history } from 'umi';
import ArchiveIcon from '@material-ui/icons/Archive';
import qs from 'qs';
import classnames from 'classnames';
import dayjs from 'dayjs';
import { DEFAULT_PERMITTEDGROUP } from '@/constants';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import IndexStyled from './IndexStyled.jsx';

const MemberManagement = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [sortField, setSortField] = useState('visitTime');
  const [sort, setSort] = useState(true);
  const [alertOpen, setAlertOpen] = useState(false);
  const { query, pathname } = location;
  const specifiedDate = dayjs();
  const oneMonthAgo = specifiedDate.subtract(30, 'day').format('YYYY-MM-DD');
  const specifiedFormatDate = dayjs().format('YYYY-MM-DD');
  // 结构到所有查询条件，包括分页条件
  const {
    idName,
    signUpDateEnd,
    signUpDateStart,
    permittedGroup = DEFAULT_PERMITTEDGROUP,
    refreshTime,
    pageNum = '1',
    pageSize = '10',
  } = query;

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['userBehavior/getTrackingLogList'];
  const { trackingLogList, trackingData } =
    useSelector((state) => state.userBehavior) || {};
  const { roleList } = useSelector((state) => state.userBehavior);
  const handleClose = () => {
    setAlertOpen(false);
  };
  // 查询事件处理
  const handleSearch = (newParam) => {
    console.log(
      '💢felix => handleSearch => newParam',

      `${pathname}?${qs.stringify({
        ...newParam,

        pageSize,
        pageNum: 1,
      })}`,
    );
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };
  // 获取权限组列表
  useEffect(() => {
    dispatch({ type: 'userBehavior/getAllRole', payload: { values: {} } });
  }, [dispatch]);

  const fetchData = useCallback(() => {
    console.log({ signUpDateStart, signUpDateEnd });
    let startTime =
      signUpDateStart === undefined ? oneMonthAgo : signUpDateStart;
    let endTime =
      signUpDateEnd === undefined ? specifiedFormatDate : signUpDateEnd;

    dispatch({
      type: 'userBehavior/getTrackingLogList',
      payload: {
        values: {
          userid: idName || null,
          endDate: endTime || null,
          startDate: startTime || null,
          pageNum,
          pageSize,
          permittedGroup,
          refreshTime,
          searchCount: false,
          sort: sort ? 'DESC' : 'ASC',
          sortField,
        },
      },
    });
  }, [
    signUpDateStart,
    signUpDateEnd,
    dispatch,
    idName,
    pageNum,
    pageSize,
    permittedGroup,
    refreshTime,
    sort,
    sortField,
  ]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onDownload = () => {
    let startTime =
      signUpDateStart === undefined ? oneMonthAgo : signUpDateStart;
    let endTime =
      signUpDateEnd === undefined ? specifiedFormatDate : signUpDateEnd;
    dispatch({
      type: 'userBehavior/exportTrackingListData',
      payload: {
        values: {
          pageNum: 1,
          permittedGroup,
          userid: idName || null,
          endDate: endTime || null,
          startDate: startTime || null,
          pageSize: 100000000,
        },
      },
      callback(res) {
        if (res.code === 0) {
          setAlertOpen(true);
        }
      },
    });
  };

  let { total, hasNext } = trackingData || {};

  return (
    <IndexStyled>
      <div className="mm_content">
        <div className={classnames('search_group', 'single_component1')}>
          <SearchGroup
            roleList={roleList}
            query={query}
            handleSearch={(par) => handleSearch(par)}
            restClick={handleRestClick}
          />
        </div>
        <div className="export-wrapper">
          <Fab
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            className="export"
            sx={{ marginRight: '16px' }}
            onClick={onDownload}
          >
            <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
            下载报表
          </Fab>
        </div>
        <div className={classnames('table_page', 'single_component')}>
          {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
          <TablePage
            pagination={{
              pageNum,
              pageSize,
            }}
            loading={loading}
            total={total}
            tableData={trackingLogList}
            hasNext={hasNext}
            setPageData={handlePageChange}
            setSortField={setSortField}
            setSort={setSort}
            sortField={sortField}
          />
        </div>
      </div>
      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          数据下载中，可在我的任务查看导出结果
        </Alert>
      </Snackbar>
    </IndexStyled>
  );
};

export default MemberManagement;
